import { PageHeader, Tabs } from '@lmc/ui-kit'
import styled from 'styled-components'
import { RotaPatternModal } from '../RotaPattern'
import { useState } from 'react'
import RotaVisitsTable from '../RotaPattern/RotaVisitsTable'
import RotaShiftsTable from '../RotaPattern/RotaShiftsTable'
import { useTranslation } from 'react-i18next'
import { getNominative } from 'common/utils'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import { AddRotaPatternDropdown } from '../RotaBuilder/common/components'
import { useTabNavigation } from 'hooks/useTabNavigation'
import useHomeType from 'hooks/useHomeType'
import NewRotaPatternModal from '../RotaPattern/NewRotaPatternModal/NewRotaPatternModal'
import useFeatureFlags from 'hooks/useFeatureFlags'
export const RotaManageVisitsScreen = () => {
  const { hasRota } = useHomeType()

  const { t } = useTranslation()

  const flags = useFeatureFlags({
    flagNames: ['new_create_pattern'],
  })?.data

  const flagsNewCreatePatternEnabled = flags?.new_create_pattern?.enabled

  const [patternModalVisible, setPatternModalVisible] = useState(false)

  const preferredPeopleNominative: string = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative || '',
  )

  const { handleTabChange, tabKey } = useTabNavigation('visits')

  if (!hasRota) {
    return null
  }

  const residentsNominative = getNominative(
    preferredPeopleNominative,
    'Residents',
  )

  const hasBanner = true

  return (
    <Container hasBanner={hasBanner}>
      <PageHeader
        title={t('MANAGE_PATTERNS')}
        subtitle={t('CREATE_VISITS_FOR_SPECIFIC', {
          variable: residentsNominative,
        })}
      >
        <AddRotaPatternDropdown />
      </PageHeader>
      {patternModalVisible &&
        (flagsNewCreatePatternEnabled ? (
          <NewRotaPatternModal
            onCancel={() => setPatternModalVisible(false)}
            type="visit"
          />
        ) : (
          <RotaPatternModal
            type="visit"
            patternModalVisible={patternModalVisible}
            onCancel={() => setPatternModalVisible(false)}
          />
        ))}
      <Tabs
        tabBarStyle={tabBarStyle}
        activeKey={tabKey}
        onChange={handleTabChange}
        items={[
          {
            key: 'visits',
            label: t('VISITS'),
            children: <RotaVisitsTable />,
          },
          {
            key: 'shifts',
            label: t('SHIFTS'),
            children: <RotaShiftsTable />,
          },
        ]}
      />
    </Container>
  )
}

const Container = styled.div<{ hasBanner?: boolean }>`
  padding: 0px 48px;
  padding: ${(props) => (props.hasBanner ? '0px 48px' : `24px 48px`)};
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const tabBarStyle = { paddingLeft: 24 }
